var _PdfEmbeddedDataValue = /** @class */ (function () {
    function _PdfEmbeddedDataValue(identification, dataValue) {
        if (identification && dataValue && dataValue.length > 0) {
            this._identification = identification;
            this._dataValue = dataValue;
        }
        else {
            throw new Error('Invalid constructor arguments: identification and non-empty dataValue are required.');
        }
    }
    _PdfEmbeddedDataValue.prototype._toString = function () {
        return ('EMBEDDED PDV { ' +
            ("identification " + this._identification.toString() + " ") +
            ("dataValue " + Array.from(this._dataValue).map(function (byte) { return byte.toString(16); }).join('') + " ") +
            '}');
    };
    _PdfEmbeddedDataValue.prototype._toJson = function () {
        return {
            identification: this._identification._toJson(),
            dataValue: Array.from(this._dataValue).map(function (byte) { return byte.toString(16); }).join('')
        };
    };
    return _PdfEmbeddedDataValue;
}());
export { _PdfEmbeddedDataValue };
